import type { TtqBehaviorId, TtqSanyAngleId } from './ttqBehaviorCatalog';
import { isTtqSanyAngleId } from './ttqBehaviorCatalog';

export type TtqWorkbenchBehaviorId =
  | TtqSanyAngleId
  | 'questions_chain'
  | 'cttq_converge'
  | 'session_aggregate_a'
  | 'session_aggregate_b';

export function isTtqWorkbenchBehavior(id: TtqBehaviorId): id is TtqWorkbenchBehaviorId {
  return isTtqSanyAngleId(id)
    || id === 'questions_chain'
    || id === 'cttq_converge'
    || id === 'session_aggregate_a'
    || id === 'session_aggregate_b';
}

export function buildTtqWorkbenchPath(
  ttqaId: string,
  behaviorId: TtqWorkbenchBehaviorId,
  particleIds: string[],
): string {
  const base = `/ttq/${encodeURIComponent(ttqaId)}/ttqworkbench`;
  const query = `particles=${particleIds.map(encodeURIComponent).join(',')}`;

  switch (behaviorId) {
    case 'pattern_unify':
      return `${base}/pattern-unify?${query}`;
    case 'multi_solution':
      return `${base}/multi-solution/${encodeURIComponent(particleIds[0])}`;
    case 'question_chain':
      return `${base}/question-chain/${encodeURIComponent(particleIds[0])}`;
    case 'questions_chain':
      return `${base}/questions-chain?${query}`;
    case 'cttq_converge':
      return `${base}/cttq-converge?${query}`;
    case 'session_aggregate_a':
      return `${base}/aggregate-a?${query}`;
    case 'session_aggregate_b':
      return `${base}/aggregate-b?${query}`;
    default:
      return `${base}/pattern-unify?${query}`;
  }
}

export function parseTtqWorkbenchParticles(searchParams: URLSearchParams): string[] {
  return (searchParams.get('particles') || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}
